var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box" },
    [
      _c("div", { staticClass: "frb" }, [
        _c(
          "div",
          {
            staticClass: "fc",
            staticStyle: { "font-weight": "bold", "font-size": "20px" },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.nameList[_vm.unionCode]) + "配置\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "add_btn pointer", on: { click: _vm.onAdd } },
          [_vm._v("添加联盟账号")]
        ),
      ]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _vm.unionCode === "TB"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "tbBizBase.memberId",
                      label: "联盟id",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "TB"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "tbBizBase.pid",
                      label: "推广位PID",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "TB"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "tbBizBase.userNick",
                      label: "授权账户",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "TB"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "tbBizBase.status",
                      label: "授权状态",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.tbBizBase.status === 0
                                ? _c("div", { staticClass: "color7F7F7F" }, [
                                    _vm._v("未授权"),
                                  ])
                                : scope.row.tbBizBase.status === 1
                                ? _c("div", { staticClass: "color70B603" }, [
                                    _vm._v("已授权"),
                                  ])
                                : scope.row.tbBizBase.status === 2
                                ? _c("div", { staticClass: "colorD9001B" }, [
                                    _vm._v("已过期"),
                                  ])
                                : _c("div", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2603462929
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "TB"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "tbBizBase.expireTime",
                      label: "授权到期时间",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.tbBizBase.expireTime) +
                                  "\n          "
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onUpdateAuth(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("更新授权")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3138162922
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "TB"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "active",
                      label: "账号状态",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.active === 1
                                ? _c("div", { staticClass: "color70B603" }, [
                                    _vm._v("默认账号"),
                                  ])
                                : _c("div", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3915096599
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "JD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "jdBizBase.unionId",
                      label: "联盟id",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "JD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "jdBizBase.status",
                      label: "授权状态",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.jdBizBase.status === 0
                                ? _c("div", { staticClass: "color7F7F7F" }, [
                                    _vm._v("未授权"),
                                  ])
                                : scope.row.jdBizBase.status === 1
                                ? _c("div", { staticClass: "color70B603" }, [
                                    _vm._v("已授权"),
                                  ])
                                : scope.row.jdBizBase.status === 2
                                ? _c("div", { staticClass: "colorD9001B" }, [
                                    _vm._v("已过期"),
                                  ])
                                : _c("div", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1128813769
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "JD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "jdBizBase.userNick",
                      label: "授权账户",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "JD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "jdBizBase.expireTime",
                      label: "授权到期时间",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.jdBizBase.expireTime) +
                                  "\n          "
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onUpdateAuth(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("更新授权")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1069100210
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "JD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "jdBizBase.active",
                      label: "账号状态",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.active === 1
                                ? _c("div", { staticClass: "color70B603" }, [
                                    _vm._v("默认账号"),
                                  ])
                                : _c("div", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3915096599
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "PDD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "pddBizBase.duoId",
                      label: "多多客id",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "PDD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "pddBizBase.mediaId",
                      label: "媒体ID",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "PDD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "pddBizBase.clientId",
                      label: "拼多多开放平台ClientId",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "PDD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "pddBizBase.clientSecret",
                      label: "拼多多开放平台ClientSecret",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "PDD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "pddBizBase.active",
                      label: "账号状态",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.active === 1
                                ? _c("div", { staticClass: "color70B603" }, [
                                    _vm._v("默认账号"),
                                  ])
                                : _c("div", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3915096599
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "WPH"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "wphBizBase.appKey",
                      label: "唯品会 AppKey",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "WPH"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "wphBizBase.appSecret",
                      label: "唯品会 AppSecret",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "WPH"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "wphBizBase.pid",
                      label: "唯品会 推广位",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.unionCode === "WPH"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "wphBizBase.active",
                      label: "账号状态",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.active === 1
                                ? _c("div", { staticClass: "color70B603" }, [
                                    _vm._v("默认账号"),
                                  ])
                                : _c("div", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3915096599
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "tips", label: "备注", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDelete(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex",
                              staticStyle: { "margin-top": "5px" },
                            },
                            [
                              scope.row.active !== 1
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { width: "122px" },
                                      attrs: {
                                        size: "mini",
                                        type: "success",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setDefault(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("设置为默认账号")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt20 page_box",
          staticStyle: { "text-align": "right" },
        },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryData.page,
              "page-sizes": [10, 20, 30, 40],
              "page-size": _vm.queryData.size,
              layout: "total, prev, pager, next, sizes,jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("AddConfiguration", {
        ref: "addConfiguration",
        on: { saveSuccess: _vm.onSaveSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }